<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  // overflow: auto;
  // width: calc(100% - 0px);
  min-width: 500px;

  .sign {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }

      .text {
        margin-left: 12px;
        color: #909399;
        font-size: 12px;
        font-family: Microsoft YaHei UI;
      }
    }

    .right {
      display: flex;
      align-items: center;
    }
  }

  .box {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .box-item-line {
      width: 20px;
      height: 100%;
    }

    .box-item {
      flex: 1;
      height: 110px;
      border: 1px solid #e4e7ed;

      // display: flex;
      // flex-direction: row;
      // flex-wrap: nowrap;
      .title {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;

        .box1 {
          flex: 1;
        }

        .box2 {
          flex: 1;
        }

        .box-item-title {
          width: 100%;
          padding-top: 23px;
          padding-left: 20px;
          color: #303133;
          font-size: 16px;
        }

        .box-item-info {
          display: flex;
          // flex-wrap: nowrap;
          flex: 2;

          // justify-content: space-between;
          // align-items: center;
          .text {
            // flex: 2;
            margin-left: 18px;
            margin-top: 14px;
            font-size: 24px;
            color: #606266;
            font-family: D-DIN Exp;

            // display: flex;
            // flex-wrap: nowrap;
            // align-items: center;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div style="display: inline;">
    <div class="container">
      <div class="form">
        <el-form style="height:28px;" :inline="true" size="mini">
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select type="organization" :ids.sync="searchForm.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="countSummaryData" plain>{{ $t('sousuo') }} </el-button>
            <el-button type="default" @click="resetSearch" plain style="margin-left: 10px;">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div>
        <div class="sign">
          <div class="left">
            <span class="icon"></span>
            <span class="txt">{{ $t('nenghaozhibiao') }}</span>
            <span class="text">{{ $t('meiri9:00gengxinzhibiaoshuju') }}</span>
          </div>
        </div>
        <div class="box" v-loading="searchLoading">
          <div style="border: 1px #E4E7ED solid;height: 110px;flex: 1;display: flex;align-items: center;padding: 20px;box-sizing: border-box;">
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p>{{ $t('zuorihaodian') }}</p>
              <p style="margin-top: 16px;">
                <span style="font-weight: 400;font-size: 32px;margin-right: 10px;">{{ summaryData.yesterdayTotalEle }}</span
                ><span style="font-size: 18px;margin-left: 4px;color: #606266;">KWH</span>
              </p>
            </div>
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p style="font-size: 12px;color: #909399;font-weight: 400;">{{ $t('zuigaohaodianshebei') }}</p>
              <p style="font-size: 12px;color: #909399;font-weight: 400;margin-top: 8px;">{{ summaryData.yesterdayMaxEleName }}</p>
              <p style="margin-top: 8px;">
                <span style="font-weight: bold;margin-right: 10px;color: #419FFF;font-size: 18px;">{{ summaryData.yesterdayMaxEleValue }}</span
                ><span style="font-size: 18px;color: #419FFF;font-weight: 400;margin-top: 8px;">KWH</span>
              </p>
            </div>
          </div>
          <div style="border: 1px #E4E7ED solid;height: 110px;flex: 1;display: flex;align-items: center;padding: 20px;box-sizing: border-box;margin-left: 20px">
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p>{{ $t('dangyuehaodian') }}</p>
              <p style="margin-top: 16px;">
                <span style="font-weight: 400;font-size: 32px;margin-right: 10px;">{{ summaryData.theMonthTotalEle }}</span
                ><span style="font-size: 18px;margin-left: 4px;color: #606266;">KWH</span>
              </p>
            </div>
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p style="font-size: 12px;color: #909399;font-weight: 400;">{{ $t('huanbitongqi') }}</p>
              <p style="margin-top: 8px;">
                <i class="el-icon-caret-bottom" style="color:#67C23A;width: 11px;height: 7px;"></i><span style="font-size: 18px;color: #419FFF;font-weight: 400;margin-top: 8px;color:#67C23A;">{{ summaryData.comparedToTheSamePeriodLastMonth }}%</span>
              </p>
            </div>
          </div>
          <div style="border: 1px #E4E7ED solid;height: 110px;flex: 1;display: flex;align-items: center;padding: 20px;box-sizing: border-box;margin-left: 20px">
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p>{{ $t('shangyuehaodian') }}</p>
              <p style="margin-top: 16px;">
                <span style="font-weight: 400;font-size: 32px;margin-right: 10px;">{{ summaryData.lastMonthTotalEle }}</span
                ><span style="font-size: 18px;margin-left: 4px;color: #606266;">KWH</span>
              </p>
            </div>
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p style="font-size: 12px;color: #909399;font-weight: 400;">{{ $t('zuigaohaodianshebei') }}</p>
              <p style="font-size: 12px;color: #909399;font-weight: 400;margin-top: 8px;">{{ summaryData.lastMonthMaxEleName }}</p>
              <p style="margin-top: 8px;">
                <span style="font-weight: bold;margin-right: 10px;color: #419FFF;font-size: 18px;">{{ summaryData.lastMonthMaxEleValue }}</span
                ><span style="font-size: 18px;color: #419FFF;font-weight: 400;margin-top: 8px;">KWH</span>
              </p>
            </div>
          </div>
          <div style="border: 1px #E4E7ED solid;height: 110px;flex: 1;display: flex;align-items: center;padding: 20px;box-sizing: border-box;margin-left: 20px;">
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p>{{ $t('jinnianleijihaodian') }}</p>
              <p style="margin-top: 16px;">
                <span style="font-weight: 400;font-size: 32px;margin-right: 10px;">{{ summaryData.theYearTotalEle }}</span
                ><span style="font-size: 18px;margin-left: 4px;color: #606266;">KWH</span>
              </p>
            </div>
            <div style="flex: 1;display: flex;flex-direction: column;align-items: center;">
              <p style="font-size: 12px;color: #909399;font-weight: 400;">{{ $t('zuigaohaodianshebei') }}</p>
              <p style="font-size: 12px;color: #909399;font-weight: 400;margin-top: 8px;">#{{ summaryData.theYearMaxEleName }}</p>
              <p style="margin-top: 8px;">
                <span style="font-weight: bold;margin-right: 10px;color: #419FFF;font-size: 18px;">{{ summaryData.theYearMaxEleValue }}</span>
                <span style="font-size: 18px;color: #419FFF;font-weight: 400;margin-top: 8px;">KWH</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="sign">
        <div class="left">
          <span class="icon"></span>
          <span class="txt">{{ $t('nenghaoqushi') }}</span>
          <span style="color: #909399;margin-left: 24px;font-size: 12px;">{{ $t('fengzhi') }}</span>
          <span style="color: #303133;font-size: 12px;margin-left: 8px;">{{ trendData.peakAndValley.peakValue.toFixed(1) }} KWH ({{ parseTime(trendData.peakAndValley.peakTime) }})</span>
          <span style="color: #909399;margin-left: 24px;font-size: 12px;">{{ $t('guzhi') }}</span>
          <span style="color: #303133;font-size: 12px;margin-left: 8px;">{{ trendData.peakAndValley.valleyValue.toFixed(1) }} KWH ({{ parseTime(trendData.peakAndValley.valleyTime) }})</span>
        </div>
        <div class="right">
          <el-form style="height:30px;" :inline="true" size="mini">
            <el-form-item>
              <yi_data_select multiple type="equipment" :placeholder="$t('suoyoushebei')" :ids.sync="searchForm.equipmentIds"></yi_data_select>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="searchForm.trendType" size="mini" :border="true" @input="inputChange">
                <el-radio-button :label="1">
                  {{ $t('ri') }}
                </el-radio-button>
                <el-radio-button :label="2">
                  {{ $t('yue') }}
                </el-radio-button>
                <el-radio-button :label="3">
                  {{ $t('nian') }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="echart">
        <div style="width: 100%;height: 400px; " id="app"></div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import dayjs from 'dayjs';
const date = new Date();
const nowTime = date.getTime();

export default {
  name: 'web_energy_management_monitoring_index',

  data() {
    return {
      searchLoading: false,
      searchForm: {
        orgId: undefined,
        equipmentIds: [],
        // 趋势类型, 1-日|2-月|3-年
        trendType: 2
      },
      summaryData: {
        comparedToTheSamePeriodLastMonth: 0.00,
        lastMonthMaxEleName: '',
        lastMonthMaxEleValue: 0,
        lastMonthTotalEle: 0,
        theMonthTotalEle: 0,
        theYearMaxEleName: '',
        theYearMaxEleValue: 0,
        theYearTotalEle: 0,
        yesterdayMaxEleName: '',
        yesterdayMaxEleValue: 0,
        yesterdayTotalEle: 0
      },
      // 趋势数据
      trendData: {
        // 时间横轴
        timeAxis: [],
        // 数据纵轴
        dataAxis: [],
        // 峰值和谷值
        peakAndValley: {
          peakTime: nowTime,
          peakValue: 0,
          valleyTime: nowTime,
          valleyValue: 0
        }
      },
      // 趋势图表对象
      trendChart: undefined
    };
  },

  created() {
    this.countSummaryData();
  },
  mounted() {
    this.trendChart = this.echarts.init(document.getElementById('app')); // this.echarts 调用
    this.setOption();
  },
  methods: {
    setOption() {
      let option = {
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '20px',
          right: '20px',
          bottom: '60px',
          top: '16%',
          containLabel: true
        },
        legend: {
          left: 'center',
          top: '5%',
          textStyle: {
            color: '#000'
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25
        },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: '#909399',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'rgba(255, 255, 255,1)',
            backgroundColor: '#F0F2F5',
            showDataShadow: true,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 14
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 14,
            color: '#909399'
          },
          data: this.trendData.timeAxis
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              rotate: 0,
              textStyle: {
                color: '#909399'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'solid',
                color: '#e4e7ed'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('suoyoushebeihaodianliang(KWH)'),
            type: 'line',
            lineStyle: {
              type: 'solid',
              color: '#419fff'
            },
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#FFFFFF',
                borderColor: '#419fff',
                borderWidth: 2
              }
            },
            data: this.trendData.dataAxis
          }
        ]
      };
      this.trendChart.setOption(option);
    },

    // 查询累计数据
    countSummaryData() {
      this.searchLoading = true;
      this.http
        .get('/web/energy/consumption/summary/data/countSummaryData', {
          params: this.searchForm
        })
        .then(res => {
          const data = res.data;
          this.summaryData = {
            comparedToTheSamePeriodLastMonth: data.comparedToTheSamePeriodLastMonth.toFixed(2),
            lastMonthMaxEleName: data.lastMonthMaxEleName,
            lastMonthMaxEleValue: data.lastMonthMaxEleValue.toFixed(1),
            lastMonthTotalEle: data.lastMonthTotalEle.toFixed(1),
            theMonthTotalEle: data.theMonthTotalEle.toFixed(1),
            theYearMaxEleName: data.theYearMaxEleName,
            theYearMaxEleValue: data.theYearMaxEleValue.toFixed(1),
            theYearTotalEle: data.theYearTotalEle.toFixed(1),
            yesterdayMaxEleName: data.yesterdayMaxEleName,
            yesterdayMaxEleValue: data.yesterdayMaxEleValue.toFixed(1),
            yesterdayTotalEle: data.yesterdayTotalEle.toFixed(1)
          };
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.searchLoading = false;
        });
      this.trend();
    },

    // 查询能耗趋势数据
    trend() {
      this.http
        .get('/web/energy/consumption/summary/data/trend', {
          params: this.searchForm
        })
        .then(res => {
          const data = res.data;
          let timeAxis = [];
          let dataAxis = [];
          if (data && data.trendRoute.length > 0) {
            const trendRoute = data.trendRoute;
            for (let i = 0; i < trendRoute.length; i++) {
              const pointData = trendRoute[i];
              const v = pointData.v != undefined ? eval(pointData.v).toFixed(1) : 0;
              timeAxis.push(this.parseTime(eval(pointData.k), true));
              dataAxis.push(v);
            }
          }
          this.trendData.peakAndValley = data.peakAndValley;
          this.trendData.timeAxis = timeAxis;
          this.trendData.dataAxis = dataAxis;
          this.setOption();
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {});
    },

    // 切换日月年时调用
    inputChange(radio) {
      this.trend();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        orgId: undefined,
        equipmentIds: [],
        // 趋势类型, 1-日|2-月|3-年
        trendType: 2
      };
      this.countSummaryData();
    },

    // 格式化时间
    parseTime(time, noYear) {
      const type = this.searchForm.trendType;
      let date;
      switch (type) {
        case 1: {
          if (noYear) {
            date = dayjs(time).format('HH:mm');
          } else {
            date = dayjs(time).format('YYYY-MM-DD HH:mm');
          }
          break;
        }
        case 3: {
          date = dayjs(time).format('YYYY-MM');
          break;
        }
        default: {
          if (noYear) {
            date = dayjs(time).format('MM-DD');
          } else {
            date = dayjs(time).format('YYYY-MM-DD');
          }
        }
      }
      return date;
    }
  }
};
</script>
